import type { $Fetch } from 'ofetch';
import type { GatewayCredencialGateway, ListGatewayCredenciaisParams } from '@/application/port/out/GatewayCredencialGateway';
import type { GatewayCredencial, UpsertGatewayCredencialCommand } from '@/domain/model/GatewayCredencial';
import type { Page } from '@/domain/model/Page';
import type { ApiResponse } from '@/infrastructure/http/types';
import { assertApiSuccess } from '@/infrastructure/http/assertApiSuccess';

const ROOT = '/api/v1/commerce/gateways/credenciais';

/** HTTP gateway de Credenciais de Gateway. Authority BE: `commerce:gateway:read|manage`. */
export class HttpGatewayCredencialGateway implements GatewayCredencialGateway {
  constructor(private readonly client: $Fetch) {}

  async list(params: ListGatewayCredenciaisParams): Promise<Page<GatewayCredencial>> {
    const res = await this.client<ApiResponse<Page<GatewayCredencial>>>(
      ROOT, { method: 'GET', params: { page: params.page, size: params.size } });
    assertApiSuccess(res);
    return res.data;
  }

  async create(cmd: UpsertGatewayCredencialCommand): Promise<GatewayCredencial> {
    const res = await this.client<ApiResponse<GatewayCredencial>>(ROOT, { method: 'POST', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async update(id: string, cmd: UpsertGatewayCredencialCommand): Promise<GatewayCredencial> {
    const res = await this.client<ApiResponse<GatewayCredencial>>(
      `${ROOT}/${encodeURIComponent(id)}`, { method: 'PUT', body: cmd });
    assertApiSuccess(res);
    return res.data;
  }

  async remove(id: string): Promise<void> {
    await this.client<void>(`${ROOT}/${encodeURIComponent(id)}`, { method: 'DELETE' });
  }
}
